import React from "react";
import Rollbar from '../utils/RollbarTracking'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from 'axios'
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

export class Orders extends React.Component {

  constructor(props)  {
    super(props);
  }

  state = {
    myOrderData: [],
    selectedOrders: [],
    selectedOrdersTotal: 0,
    loading: false
  }

  componentWillMount() {
    this.fetchOrderData();
  }

  fetchOrderData = async () => {
    axios.get('/orders')
        .then(data => {
          this.setState({
            myOrderData: data
          });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to get all orders')
        })
  }

  acceptAllOrders = async () => {
    axios.post('/orders/acceptall')
        .then(data => {
          toast.success("Orders Accepted!");
          this.fetchOrderData();
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to accept all orders')
        })
  }

  invoiceAllOrders = async () => {
    this.setState({loading: true})
    toast.warning('Generating Invoices...please wait', {autoClose: false})
    axios.post('/orders/invoiceall')
        .then(data => {
          this.setState({loading: false})
          toast.dismiss()
          this.fetchOrderData();
          toast.success("Orders Invoiced!");
        })
        .catch (err => {
          this.setState({loading: false})
          toast.dismiss()
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to invoice all orders')
        })
  }

  cellButton(cell, row, enumObject, rowIndex) {
    return (
       <Link to={'/orders/view/' + row.orderID}><button type="button" className="btn btn-info btn-sm">View</button></Link>
    )
  }

  statusFormatter(cell, row) {
    if (cell === 'Pending') {
      return '<span class="badge badge-warning">Pending</span>'
    }
    else if (cell === 'Accepted') {
      return '<span class="badge badge-info">Accepted</span>'
    }
    else if (cell === 'Invoiced') {
      return '<span class="badge badge-success">Invoiced</span>'
    }
    else if (cell === 'Paid') {
      return '<span class="badge badge-secondary">Paid</span>'
    }
  }

  // Mark as paid multi select
  onRowSelect(row, isSelected, e) {
    let selectedOrders = this.state.selectedOrders
    let selectedOrdersTotal = this.state.selectedOrdersTotal
    if (isSelected) {
      selectedOrders.push(row.orderID)
      selectedOrdersTotal += Number(row.total)
    } else {
      selectedOrders = selectedOrders.filter(item => item !== row.orderID)
      selectedOrdersTotal -= Number(row.total)
    }
    this.setState({ selectedOrders: selectedOrders, selectedOrdersTotal: selectedOrdersTotal })
  }

  onSelectAll(isSelected, rows) {
    if (isSelected) {
      let selectedOrders = this.state.selectedOrders
      let selectedOrdersTotal = this.state.selectedOrdersTotal
      for (let i = 0; i < rows.length; i++) {
        selectedOrders.push(rows[i].orderID)
        selectedOrdersTotal += Number(rows[i].total)
      }
      this.setState({ selectedOrders: selectedOrders, selectedOrdersTotal: selectedOrdersTotal })
    } else {
      this.setState({ selectedOrders: [], selectedOrdersTotal: 0 })
    }
  }

  updateOrderStatuses = async (newStatus, prevStatus) => {
    let requestParams = {
      'status': newStatus,
      'orders': this.state.selectedOrders,
      'prevStatus': prevStatus
    }
    axios.post('/orders/update/status/bulk', requestParams)
        .then(data => {
          this.fetchOrderData();
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to update order statuses')
        })
  }

  // Filter/search
  filterChange(evt) {
    this.refs.nameFilter.applyFilter(evt.target.value);
  }

    render() {
        return (
          <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Orders</h1>
            </div>
            <div className="row">
              <div className="col-sm-9 my-auto">
                <Link to={'/orders/create'}><button type="button" className="btn btn-warning btn-sm mar-bot">Create Order</button></Link>
                <button type="button" onClick={this.acceptAllOrders} className="btn btn-info btn-sm mar-bot ml-2">Accept All</button>
                <button type="button" onClick={this.invoiceAllOrders} className="btn btn-success btn-sm mar-bot ml-2" disabled={this.state.loading}>Invoice All</button>
                {!this.props.settings.integration.type ? <button type="button" onClick={() => this.updateOrderStatuses('Paid', 'Invoiced')} className="btn btn-secondary btn-sm mar-bot ml-2" disabled={!this.state.selectedOrders.length}>Mark ({this.state.selectedOrders.length}) as Paid</button>: null}
                {/* <Link to={'/orders/freshproduce'}><button type="button" className="btn btn-secondary btn-sm mar-bot ml-2">Set Prices for Today</button></Link> */}
                {!this.props.settings.integration.type ? <div className="d-inline-block text-bold ml-2">Selected Total: <strong>${this.state.selectedOrdersTotal.toFixed(2)}</strong></div>: null}
              </div>
              <div className="col-sm-3 my-auto">
                <div className="input-group mar-bot">
                  <div className="input-group-prepend">
                    <span className="input-group-text"><i className="fa fa-search"></i></span>
                  </div>
                  <input type="text" className="form-control" placeholder="Customer..." onChange={this.filterChange.bind(this)}/>
                </div>
              </div>
            </div>
            <BootstrapTable data={this.state.myOrderData} options={{sizePerPage: 50}} striped={true} hover={true} selectRow={!this.props.settings.integration.type ? { mode: 'checkbox', onSelect: this.onRowSelect.bind(this), onSelectAll: this.onSelectAll.bind(this), columnWidth: '2.75em' } : false} pagination>
                  <TableHeaderColumn dataField="orderID" isKey={true} dataSort={true} width="100" >No.</TableHeaderColumn>
                  <TableHeaderColumn dataField="company" dataSort={true} ref='nameFilter' filter={ { type: 'TextFilter' } } width="175">Customer</TableHeaderColumn>
                  <TableHeaderColumn dataField="date" dataSort={true} width="180">Date</TableHeaderColumn>
                  <TableHeaderColumn dataField="total" width="125">Total</TableHeaderColumn>
                  <TableHeaderColumn dataField="deliveryDay" dataSort={true} width="165">Delivery Day</TableHeaderColumn>
                  <TableHeaderColumn dataField="status" dataFormat={this.statusFormatter} dataSort={true} width="85">Status</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={this.cellButton} width="95">Action</TableHeaderColumn>
            </BootstrapTable>
          </div>
        );
    }
}
